import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface MobileListItemFieldProps {
  label: string;
  value: ReactNode;
  className?: string;
}

export function MobileListItemField({
  label,
  value,
  className,
}: MobileListItemFieldProps) {
  return (
    <div className={cn("flex justify-between items-center", className)}>
      <span className="text-sm text-gray-600">{label}:</span>
      <span className="text-sm font-medium text-gray-900 text-right flex-1 ml-2 truncate">
        {value}
      </span>
    </div>
  );
}
